/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { getAreaList } from '../../../constants/AREA';
import { classnames } from '../../../utils/text';
import GoogleMapReact from "google-map-react";
import { Marker } from '../../../components/Map/Marker';
import { isNull, range, sortBy } from 'lodash';
import Button from '../../../components/Button';
import ButtonArrow from "../../../assets/images/icon/common/button-arrow.svg";
import WorkBag from "../../../assets/images/icon/common/work-bag.svg";
import LocationIcon from "../../../assets/images/partners/location-icon.png";
import { transformMobile } from '../../../utils/validator/mobile';
import PageNationLeft from "../../../assets/images/partners/pagination-left.png";
import PageNationRight from "../../../assets/images/partners/pagination-right.png";
import Icon from '../../../components/Icon';
import Modal, { ModalHeader } from '../../../components/Modal';
import { getLocation } from '../../../utils/gps';
import { isEmpty } from '../../../utils/lodashExtend';
import { getCollaborationCompanies } from '../../../apis/tax-portal/tax-consulting';
import TaxConsultingCollaborationDetail from './TaxConsultingCollaborationDetail';
import { shallowEqual, useSelector } from 'react-redux';
import NoData from '../../../components/NoData/NoData';
import TaxEmployeePreviewModal from '../../../components/TaxConsulting/TaxEmployeePreviewModal';

const TaxConsultingCollaborationCompanies = ({ category, parentCategory, isOpen, setIsOpen, ...props }) => {
  const mapRef = useRef(null);
  const limit = 5;
  const [page, setPage] = useState(0);
  const [employees, setEmployees] = useState([]);
  const [mapCompanies, setMapCompanies] = useState([]);
  const [allCompanies, setAllCompanies] = useState([]);
  const [areaFilter, setAreaFilter] = useState(getAreaList()[0]);
  const [total, setTotal] = useState(null);
  const [_searchText, _setSearchText] = useState("");
  const [searchText, setSearchText] = useState("");
  const { employee } = useSelector(
    (store) => ({
      employee: store.Profile.employee,
    }),
    shallowEqual
  );
  const defaultCenter = {
    // 수도권
    lat: getAreaList()[0].latitude,
    lng: getAreaList()[0].longitude,
  };
  const [center, setCenter] = useState(defaultCenter);
  const [zoom, setZoom] = useState(getAreaList()[0].zoom);
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [nextStepOpen, setNextStepOpen] = useState(false);
  const [categoryName, setCategoryName] = useState('');


  const close = () => {
    setIsOpen(false);
    setSelectedItem(null);
    setCategoryName('');
  };

  const search = () => {
    setSearchText(_searchText);
  };

  const pageMoveMap = () => {
    document.getElementsByClassName("modal")[0].scrollTop = 0;
  };

  const moveMap = ({ longitude, latitude, zoom: _zoom }) => {
    setCenter({
      lat: defaultCenter.lat - 0.00001,
      lng: defaultCenter.lng - 0.00001,
    });
    setZoom(0);
    setTimeout(() => {
      setZoom(_zoom || 15);
      setCenter({
        lat: Number(latitude),
        lng: Number(longitude),
      });
    });
  };

  const moveCompanyMap = (partner) => {
    if (partner && partner.latitude) {
      moveMap(partner);
    }
  };

  // 좌표에 따른 불러오기
  const settingCompanies = async (_partners) => {
    let coord = {};
    try {
      coord = await getLocation();
    } catch (error) {
      console.error("좌표 사용 불가");
    }

    let __partners = _partners.map(
      ({ latitude = 0, longitude = 0, ...partner }) => {
        let distance = 500000;
        if (coord.latitude && coord.longitude)
          distance =
            Math.abs(
              Number(latitude) * 10000 - Number(coord.latitude) * 10000
            ) +
            Math.abs(
              Number(longitude) * 10000 - Number(coord.longitude) * 10000
            );
        return {
          ...partner,
          latitude,
          longitude,
          distance,
        };
      }
    );

    if (coord.latitude && coord.longitude)
      __partners = sortBy(__partners, "distance");
    setAllCompanies(__partners);
    setMapCompanies(__partners);
    setEmployees(__partners.slice(limit * page, (page + 1) * limit));
    setTotal(__partners.length);
  };

  useEffect(() => {
    setEmployees(allCompanies.slice(limit * page, (page + 1) * limit));
  }, [page])

  // 최초 세팅
  const getData = (category) => {
    getCollaborationCompanies(category.idx)
      .then(res => {
        if (!isEmpty(res)) {
          const _employees = res.filter(f => f.employeeIdx !== employee.employeeIdx);
          setAllCompanies(_employees);
          setMapCompanies(_employees);
          setEmployees(_employees.slice(limit * page, (page + 1) * limit));
          setTotal(_employees.length);
          setTimeout(() => {
            settingCompanies(_employees);
          }, 1000);
        }
      });
  };

  // 필터 적용
  useEffect(() => {
    if (!isEmpty(allCompanies) && !isEmpty(areaFilter)) {
      const companies = [];
      allCompanies.forEach((company) => {
        if (
          areaFilter.name === "전체" ||
          areaFilter.name.split("·").includes(company.area)
        )
          if (
            (company.name || '').includes(searchText) ||
            (company.address || '').includes(searchText) ||
            (company.addressDetail || '').includes(searchText) ||
            (company.ceoName || '').includes(searchText) ||
            (company.mainTask || "").includes(searchText)
          ) {
            companies.push(company);
          }
      });
      moveMap(areaFilter);
      setMapCompanies(companies);
      setEmployees(companies.slice(limit * page, (page + 1) * limit));
      setTotal(companies.length);
      setPage(0);
    }
  }, [areaFilter, searchText]);


  useEffect(() => {
    if (!isEmpty(category) && employee) {
      getData(category);
    }
  }, [isOpen, employee]);


  return (
    <>
      <Modal
        className="trial-request-partner-modal"
        isOpen={isOpen}
        close={close}
      >
        <ModalHeader>
          {`${category?.name} 컨설팅 협업 가능한 세무사`}
          <p>
            <small>
              (위치권한을 승인하면 가까운 순서로 보실 수 있습니다.)
            </small>
          </p>
        </ModalHeader>
        <div className="wecake-partners-wrap">
          {/* <div direction="column"></div>  */}
          <div className="wecake-partners-tabs">
            {getAreaList()?.map((area, index) => (
              <div
                onClick={() => setAreaFilter(area)}
                className={classnames("tab-item", {
                  active: areaFilter === area,
                })}
                key={index}
              >
                <div>{area.name}</div>
              </div>
            ))}
          </div>
          <div className="google-map-wrap" ref={mapRef}>
            <div className="google-map-box">
              <GoogleMapReact
                bootstrapURLKeys={{
                  key: process?.env?.REACT_APP_GOOGLE_MAP_KEY || "",
                }}
                center={center}
                zoom={zoom}
              >
                {mapCompanies.map((taxCompany, idx) => (
                  <Marker
                    key={idx}
                    idx={idx}
                    lat={taxCompany.latitude}
                    lng={taxCompany.longitude}
                    name={taxCompany.name}
                  />
                ))}
              </GoogleMapReact>
            </div>
          </div>
          <div className="weckae-partners-table-wrap">
            {!isEmpty(employees) ? (
              <>
                <div className="wecake-partners-filter-wrap">
                  <div className="count-wrap">
                    {!isNull(total) && <>Total : {total}</>}
                  </div>

                  <div className="filter-wrap">
                    <input
                      placeholder="검색어를 입력하세요"
                      onChange={(e) => _setSearchText(e.target.value)}
                    />
                    <Button onClick={search}>검색</Button>
                  </div>
                </div>
                <div className="wecake-partners-table">
                  {employees.map((employee, idx) => (
                    <div className="wecake-partners-table-row" key={idx}>
                      <div className="parnter-name-wrap">
                        <div className="partner-name">
                          {employee.name} 세무사님
                        </div>
                        {employee.code && (
                          <div className="code-label">{employee.companyName}</div>
                        )}
                      </div>
                      <div className="partner-info-wrap">
                        {employee.address && (
                          <div className="parnter-address">
                            {employee.address} {employee.addressDetail}{" "}
                            <Button
                              color={"gray-line"}
                              onClick={() => {
                                pageMoveMap();
                                moveCompanyMap(employee);
                              }}
                            >
                              <img src={LocationIcon} alt="" />
                              위치보기
                            </Button>
                          </div>
                        )}
                        <div className="partner-contact-wrap">
                          {employee.tel && (
                            <div className="tel">
                              Tel : {transformMobile(employee.tel)}
                            </div>
                          )}
                          {/* <div>
                            소속 회사명 : {employee.companyName}
                          </div> */}
                        </div>

                        <div className="main-task-wrap">
                          <div className="main-task-label">
                            <Icon width={"14px"} height={"14px"} src={WorkBag} />
                            <span>주요 업무</span> |{" "}
                          </div>
                          <div className="main-task">
                            <div
                              dangerouslySetInnerHTML={{
                                __html:
                                  employee.mainTask?.split("\n").join(", ") ||
                                  "회계, 세무, 경영지원 외",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="partner-button-wrap">
                        <Button
                          className="detail-button"
                          color="line"
                          onClick={() => {
                            // 선택
                            setNextStepOpen(true);
                            setCategoryName(`${parentCategory?.name}-${category?.name}`);
                            setSelectedItem(employee);
                          }}
                        >
                          <div>컨설팅 협업 요청</div>
                          <Icon className="button" src={ButtonArrow} />
                        </Button>

                        <Button
                          className="detail-button"
                          color="gray-line"
                          onClick={() => {
                            // 선택
                            setIsDetailOpen(true);
                            setSelectedItem(employee);
                          }}
                        >
                          <div>자세히보기</div>
                          <Icon className="button" src={ButtonArrow} />
                        </Button>
                      </div>
                    </div>
                  ))}
                </div>
                {/* pagination */}
                {(total || 0) > limit && (
                  <div className="pagination-wrap">
                    {page !== 0 && (
                      <Button color="text" onClick={() => setPage(page - 1)}>
                        <img src={PageNationLeft} alt="" />
                      </Button>
                    )}
                    {range(Math.ceil((total || 0) / limit)).map((p, idx) => (
                      <Button
                        className={classnames({ active: page === p })}
                        idx={idx}
                        color="text"
                        onClick={() => setPage(p)}
                      >
                        {p + 1}
                      </Button>
                    ))}

                    {page !== Math.ceil((total || 0) / limit) - 1 && (
                      <Button color="text" onClick={() => setPage(page + 1)}>
                        <img src={PageNationRight} alt="" />
                      </Button>
                    )}
                  </div>
                )}
              </>
            ) : (
              <NoData text="협업 가능한 세무사가 존재하지 않습니다." />
            )}

          </div>

        </div>
      </Modal>

      <TaxEmployeePreviewModal
        isOpen={isDetailOpen}
        onClose={setIsDetailOpen}
        employee={selectedItem}
      />

      <TaxConsultingCollaborationDetail
        open={nextStepOpen}
        setOpen={setNextStepOpen}
        selectedItem={selectedItem}
        categoryName={categoryName}
        orgMode={"create"}
        categoryIdx={category?.idx}
      />
    </>
  );
};

export default TaxConsultingCollaborationCompanies;